export default {
    openedPaneIds: true,
    currentPrimaryPaneOptionComponentId: true,
    paneOptionsComponents: true,
    navOpen: true, // Persist the nav's open/closed state (the Nav webview owns it — plan 2026-07-15).
};